/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.playback.getLivePlaylist";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"streamer":/*#__PURE__*/ l.string(),"track":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"sid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"token":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.payload("*/*");

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get an HLS CMAF playlist for a live stream. Returns a master playlist when `track` is omitted, or a single-track media playlist when `track` is supplied. The playlist references each segment + per-track init segment via getLiveSegment. Segments come from an in-memory sliding window fed as the stream is ingested (or replicated to this node), so a playlist is only available while the stream is live here. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["StreamNotLive","TrackNotFound","StreamUnavailable"]);

export { main };

export const $lxm = $nsid;
